export function getVisibilityChangeNamespace(prefix) {
  return `${prefix}visibilitychange`;
}